import styled from 'styled-components';
import { Button } from '@/ui';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { CheckmarkCircleIcon } from '@/icons';

export const StyledStatusButton = styled(Button)`
  &&& {
    width: 10.125rem;
    height: 2.25rem;
    ${pickThemeFontStyles('12', '18', 'BOLD')};

    svg {
      path {
        fill: ${COLORS.WHITE};
      }
    }
  }
`;

export const StyledCheckmarkCircleIcon = styled(CheckmarkCircleIcon)`
  transform: scale(0.8);
`;

export const StyledButton = styled(Button)`
  &&& {
    width: 6.563rem;
    height: 2.25rem;
    background: ${COLORS.DARK};
    color: ${COLORS.WHITE};
    ${pickThemeFontStyles('12', '18', 'BOLD')};

    :hover {
      background: ${COLORS.DARK};
      color: ${COLORS.WHITE};
    }
  }
`;
